export default __webpack_public_path__ + "static/media/UTD.08ed9e14.svg";